import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProductForm from "../pages/ProductForm";
import { productApi } from "../api/productApi";

export default function ProductEdit() {
  const { id } = useParams();
  const nav = useNavigate();

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await productApi.get(id);
      setItem(res.data || null);
    } catch (e) {
      setErr(e?.response?.data || e.message || "Load failed");
      setItem(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [id]);

  const onSubmit = async (formData) => {
    setSaving(true);
    try {
      await productApi.update(id, formData);
      nav("/products");
    } catch (e) {
      alert(e?.response?.data || e.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="card">
        <div className="cardBody">Yüklənir...</div>
      </div>
    );
  }

  if (err) {
    return (
      <div className="card">
        <div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>
          {String(err)}
        </div>
      </div>
    );
  }

  if (!item) return null;

  return (
    <div>
      <h1 className="pageTitle">Redakte et #{id}</h1>

      <div className="card" style={{ marginBottom: 12 }}>
        <div className="cardBody" style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <div style={{ fontWeight: 800 }}>Mövcud şəkil:</div>
          {item.hasImage ? (
            <img
              className="imgThumb"
              alt="product"
              src={productApi.getImageUrl(item.id) + `?t=${Date.now()}`}
            />
          ) : (
            <span className="badge badgeNo">Şəkil yoxdur</span>
          )}
        </div>
      </div>

      <ProductForm initial={item} onSubmit={onSubmit} submitText="Save" saving={saving} />
    </div>
  );
}
